import { VisualizationInstance } from "../../model/viz/VisualizationInstance";
import { TFunction } from "i18next";

export const getTitle = (vizInstance:VisualizationInstance, t:TFunction):string => {
  const title: any = vizInstance.definition.uiParams.title;
  if(title) {
    return t(title?.key ? title.key : `viz.${vizInstance.dashboard.id}.${vizInstance.definition.id}.title`, title) as string;
  }
  return null;
}